export const CONTACT_INFO = {
  email: 'whaid@heritiqueintl.com',
  phone: '+1 (347) 698-5455',
  phoneRaw: '01XXX', // Display format for some contexts
  address: '30 N GOULD ST 42588\nSHERIDAN WY 82801',
  owner: 'A B M Whaiduzzaman',
  ownerTitle: 'Owner'
} as const;
